export const INBOX_SIDEBAR_WIDTH_STORAGE_KEY = "amoreg:inbox-list-width:v1";
export const INBOX_SIDEBAR_MIN_WIDTH = 280;
export const INBOX_SIDEBAR_MAX_WIDTH = 560;

export function resolveInboxSidebarWidth(
  storedWidth: number | null,
  availableWidth: number,
): number {
  const preferred = storedWidth !== null && Number.isFinite(storedWidth) ? storedWidth : 380;
  const maximum = Math.max(
    INBOX_SIDEBAR_MIN_WIDTH,
    Math.min(INBOX_SIDEBAR_MAX_WIDTH, availableWidth * 0.42),
  );
  return Math.max(INBOX_SIDEBAR_MIN_WIDTH, Math.min(preferred, maximum));
}
